export default __webpack_public_path__ + "static/media/10.2b66a025.png";